import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'pt-br',
  silentTranslationWarn: true,
  messages: {
    'pt-br': {
      accounts: {
        label: 'Contas'
      },
      account: {
        label: 'Conta'
      },
      active: {
        label: 'Ativo'
      },
      addition: {
        label: 'Acréscimo'
      },
      admin: {
        label: 'Administrador'
      },
      method: {
        label: 'Método de pagamento'
      },
      adult: {
        label: 'Adulto'
      },
      ageGroup: {
        adult: {
          label: 'Adulto'
        },
        both: {
          label: 'Ambos'
        },
        kids: {
          label: 'Crianças'
        },
        label: 'Faixa etária'
      },
      amazon: {
        account: {
          label: 'Conta'
        },
        accounts: {
          active: {
            label: 'Ativo'
          },
          inactive: {
            label: 'Inativo'
          },
          label: 'Contas'
        },
        feed: {
          create: {
            label: 'Criar'
          },
          created: {
            label: 'Data de criação'
          },
          label: 'Carga',
          list: {
            label: 'Cargas'
          },
          queued: {
            false: {
              label: 'Não'
            },
            true: {
              label: 'Sim'
            }
          },
          statuses: {
            available: {
              label: 'Disponível para consulta'
            },
            created: {
              label: 'Criado'
            },
            done: {
              label: 'Finalizado'
            },
            error: {
              label: 'Erro'
            },
            forward_error: {
              label: 'Erro consulta'
            },
            lookup_error: {
              label: 'Erro consulta'
            },
            processing: {
              label: 'Processando'
            },
            submitted: {
              label: 'Enviado'
            }
          },
          type: {
            image: {
              label: 'Imagem'
            },
            label: 'Tipo',
            order: {
              label: 'Pedido'
            },
            price: {
              label: 'Preço'
            },
            stock: {
              label: 'Estoque'
            },
            sync: {
              label: 'Produto'
            }
          }
        },
        feeds: {
          label: 'Cargas'
        },
        label: 'Amazon',
        status: {
          pending: {
            label: 'Aguardando carga'
          }
        }
      },
      analyzing: {
        label: 'Aguardando aprovação'
      },
      additional: {
        label: 'Adicional'
      },
      analyzing_deleted: {
        label: 'Exclusão solicitada'
      },
      Anatel: {
        label: 'Anatel'
      },
      announcement: {
        label: 'Anunciar'
      },
      announcements: {
        label: 'Anúncios'
      },
      sizegrids: {
        label: 'Guia de Medidas'
      },
      api: {
        label: 'API'
      },
      apply: {
        label: 'Aplicar'
      },
      approved: {
        label: 'Aprovado'
      },
      batch: {
        label: 'Ações em lote',
        statuses: {
          canceled: {
            label: 'Cancelado'
          },
          done: {
            label: 'Finalizado'
          },
          error: {
            label: 'Erro'
          },
          pending: {
            label: 'Pendente'
          },
          pre_processing: {
            label: 'Pré-processando'
          },
          processing: {
            label: 'Processando'
          }
        }
      },
      billingAddress: {
        label: 'Endereço de cobrança'
      },
      both: {
        label: 'Ambos'
      },
      brand: {
        label: 'Marca'
      },
      bulkActions: {
        label: 'Selecione uma ação'
      },
      bulkPrice: {
        label: 'Alterar preço dos produtos'
      },
      canceled: {
        label: 'Cancelado'
      },
      capacity: {
        label: 'Capacidade'
      },
      cannotSend: {
        label: 'Não pode ser enviado'
      },
      cataloging: {
        label: 'Catalogando'
      },
      capsule: {
        label: 'Cápsula'
      },
      categorization: {
        label: 'Categorização'
      },
      category: {
        label: 'Categoria'
      },
      codes: {
        label: 'Códigos'
      },
      carrefour: {
        feed: {
          create: {
            label: 'Criar'
          },
          created: {
            label: 'Data de criação'
          },
          label: 'Carga',
          list: {
            label: 'Cargas'
          },
          queued: {
            false: {
              label: 'Não'
            },
            true: {
              label: 'Sim'
            }
          },
          statuses: {
            created: {
              label: 'Criado'
            },
            error: {
              label: 'Erro'
            },
            forward_error: {
              label: 'Erro consulta'
            },
            processing: {
              label: 'Processando'
            },
            done: {
              label: 'Finalizado'
            }
          },
          type: {
            label: 'Tipo',
            price: {
              label: 'Atualização de Preço'
            },
            stock: {
              label: 'Atualização de Estoque'
            },
            sync: {
              label: 'Sincronização de Produto'
            }
          }
        },
        label: 'Carrefour',
        feeds: {
          label: 'Cargas'
        },
        status: {
          pending: {
            label: 'Aguardando carga'
          }
        }
      },
      centauro: {
        label: 'Centauro',
        error: {
          warrantyTime: {
            zeroValue: {
              label: 'O tempo de garantia precisa ser maior que 0'
            }
          }
        }
      },
      channel: {
        label: 'Canal'
      },
      choose: {
        label: 'Escolha'
      },
      console: {
        label: 'Console'
      },
      select: {
        label: 'Selecione'
      },
      city: {
        label: 'Cidade'
      },
      client: {
        label: 'Cliente'
      },
      clientName: {
        label: 'Nome do cliente'
      },
      closed: {
        label: 'Finalizado'
      },
      cnova: {
        label: 'Cnova',
        status: {
          confirm: {
            label: 'Aguardando confirmação'
          },
          match: {
            label: 'Aguardando match'
          }
        }
      },
      code: {
        label: 'Código'
      },
      colombo: {
        label: 'Colombo'
      },
      color: {
        label: 'Cor'
      },
      colorMap: {
        label: 'Cor Marketplace'
      },
      complement: {
        label: 'Complemento'
      },
      condition: {
        label: 'Condição'
      },
      conectaLa: {
        label: 'Conecta Lá'
      },
      configuration: {
        label: 'Configuração'
      },
      configurations: {
        label: 'Configurações'
      },
      contains: {
        label: 'Contém'
      },
      createdAt: {
        label: 'Data de criação'
      },
      crossDocking: {
        label: 'Prazo extra'
      },
      current: {
        label: 'Atual'
      },
      custom: {
        color: {
          label: 'Cores personalizadas'
        },
        label: 'Customizado',
        size: {
          label: 'Tamanhos personalizados'
        },
        brand: {
          label: 'Marcas Personalizadas'
        },
        model: {
          label: 'Modelos personalizados'
        },
        team: {
          label: 'Time personalizado'
        }
      },
      customerName: {
        label: 'Nome do cliente'
      },
      dashboard: {
        label: 'Dashboard'
      },
      data_source: {
        label: 'Fonte de dados'
      },
      date: {
        label: 'Data',
        created: {
          label: 'Data de criação'
        }
      },
      default: {
        color: {
          label: 'Cores padrões'
        },
        label: 'Padrão',
        size: {
          label: 'Tamanhos padrões'
        },
        brand: {
          label: 'Marcas Padrões'
        },
        model: {
          label: 'Modelo'
        },
        team: {
          label: 'Time'
        }
      },
      deleted: {
        label: 'Apagado'
      },
      delivered: {
        label: 'Entregue'
      },
      delivery: {
        label: 'Entrega'
      },
      deliveryAddress: {
        label: 'Endereço de entrega'
      },
      denied: {
        label: 'Reprovado'
      },
      details: {
        label: 'Detalhes'
      },
      department: {
        label: 'Departamento'
      },
      departments: {
        label: 'Departamentos'
      },
      dimensions: {
        label: 'Dimensões',
        mm: {
          label: 'Milímetro'
        },
        cm: {
          label: 'Centímetro'
        },
        m: {
          label: 'Metro'
        }
      },
      discount: {
        label: 'Desconto'
      },
      district: {
        label: 'Bairro'
      },
      displayList: {
        label: 'Exibição da listagem'
      },
      done: {
        label: 'Finalizar'
      },
      duplicated: {
        label: 'Campo duplicado'
      },
      ecommerce: {
        label: 'E-commerce'
      },
      edit: {
        label: 'Editar'
      },
      delete: {
        label: 'Deletar'
      },
      email: {
        label: 'E-mail'
      },
      equals: {
        label: 'Campo deve ser igual a \'{msg}\''
      },
      erp: {
        label: 'Erp'
      },
      error: {
        label: 'Erro'
      },
      exchange: {
        label: 'Troca',
        approved: {
          label: 'Aprovado troca'
        }
      },
      expediter: {
        label: 'Expedição',
        code: {
          label: 'Código do Expeditor'
        }
      },
      externalCode: {
        label: 'Código externo'
      },
      fail: {
        label: 'Falha'
      },
      failed_sync: {
        label: 'Falha de sincronização',
        message: {
          label: 'Falha ao sincronizar todas variações'
        }
      },
      false: {
        label: 'Não'
      },
      family: {
        label: 'Família'
      },
      feed: {
        label: 'Carga'
      },
      fixedValue: {
        label: 'Valor fixo sobre o preço de venda'
      },
      flavor: {
        label: 'Sabor'
      },
      flexy: {
        label: 'Flexy'
      },
      freightValue: {
        label: 'Valor do frete'
      },
      frenet: {
        label: 'Frenet'
      },
      from: {
        label: 'Origem'
      },
      fullNameHierarch: {
        label: 'Nome Completo (Hierarquia)'
      },
      file: {
        label: 'Arquivo'
      },
      gender: {
        female: {
          label: 'Feminino'
        },
        label: 'Gênero',
        male: {
          label: 'Masculino'
        },
        unisex: {
          label: 'Unissex'
        }
      },
      general: {
        label: 'Geral'
      },
      gfg: {
        feed: {
          create: {
            label: 'Criar'
          },
          created: {
            label: 'Data de criação'
          },
          label: 'Carga',
          list: {
            label: 'Cargas'
          },
          queued: {
            false: {
              label: 'Não'
            },
            true: {
              label: 'Sim'
            }
          },
          statuses: {
            created: {
              label: 'Criado'
            },
            error: {
              label: 'Erro'
            },
            processing: {
              label: 'Processando'
            },
            done: {
              label: 'Finalizado'
            },
            forward_error: {
              label: 'Erro consulta'
            }
          },
          type: {
            image: {
              label: 'Sincronização de Imagem'
            },
            label: 'Tipo',
            price: {
              label: 'Atualização de Preço'
            },
            stock: {
              label: 'Atualização de Estoque'
            },
            sync: {
              label: 'Sincronização de Produto'
            }
          }
        },
        feeds: {
          label: 'Cargas'
        },
        label: 'GFG',
        status: {
          pending: {
            label: 'Aguardando carga'
          }
        }
      },
      hasVariationsCombination: {
        label: 'Possui variação'
      },
      httpMethod: {
        label: 'Método HTTP'
      },
      id: {
        label: 'Identificador'
      },
      identifier: {
        label: 'Identificador'
      },
      inch: {
        label: 'Polegada'
      },
      image: {
        label: 'Imagem'
      },
      inactive: {
        label: 'Inativo'
      },
      installments: {
        label: 'Parcelas'
      },
      integracommerce: {
        gridType: {
          size: {
            label: 'Tamanho'
          },
          flavor: {
            label: 'Sabor'
          },
          voltage: {
            label: 'Voltagem'
          }
        },
        label: 'Integracommerce'
      },
      integration: {
        label: 'Integração'
      },
      intelipost: {
        label: 'Intelipost'
      },
      invoice: {
        label: 'Faturado'
      },
      invoiced: {
        label: 'Faturado'
      },
      items: {
        found: {
          label: 'Nenhum registro encontrado | 1 registro encontrado | {count} registros encontrados'
        },
        label: 'Itens'
      },
      label: {
        label: 'Nome'
      },
      level: {
        critical: {
          label: 'Crítico'
        },
        info: {
          label: 'Informação'
        },
        label: 'Nível',
        warning: {
          label: 'Alerta'
        }
      },
      leroy: {
        feed: {
          create: {
            label: 'Criar'
          },
          created: {
            label: 'Data de criação'
          },
          label: 'Carga',
          list: {
            label: 'Cargas'
          },
          queued: {
            false: {
              label: 'Não'
            },
            true: {
              label: 'Sim'
            }
          },
          statuses: {
            created: {
              label: 'Criado'
            },
            error: {
              label: 'Erro'
            },
            processing: {
              label: 'Processando'
            },
            done: {
              label: 'Finalizado'
            }
          },
          type: {
            label: 'Tipo',
            price: {
              label: 'Atualização de Preço'
            },
            stock: {
              label: 'Atualização de Estoque'
            },
            sync: {
              label: 'Sincronização de Produto'
            }
          }
        },
        feeds: {
          label: 'Cargas'
        },
        label: 'Leroy Merlin',
        status: {
          pending: {
            label: 'Aguardando carga'
          }
        }
      },
      list: {
        label: 'Listagem'
      },
      logout: {
        label: 'Desconectar'
      },
      logs: {
        label: 'Histórico'
      },
      lookup_error: {
        label: 'Erro Consulta'
      },
      lowestPrice: {
        label: 'Menor preço'
      },
      madeira: {
        attributes: {
          label: 'Atributos'
        },
        label: 'Madeira Madeira'
      },
      magalu: {
        label: 'Magalu',
        account: {
          label: 'Conta'
        },
        accounts: {
          active: {
            label: 'Ativo'
          },
          inactive: {
            label: 'Inativo'
          },
          label: 'Contas'
        },
        actions: {
          status: {
            activate: {
              label: 'Ativar'
            },
            pause: {
              label: 'Pausar'
            }
          }
        }
      },
      manufacturerReference: {
        label: 'Referência do Fabricante'
      },
      match: {
        label: 'Aguardando match'
      },
      marketplace: {
        label: 'Marketplace'
      },
      marketplaceDate: {
        label: 'Data de criação no Marketplace'
      },
      markup: {
        label: 'Margem sobre preço de custo'
      },
      maxInstallment: {
        label: 'Máximo parcelamento'
      },
      mercadoLivre: {
        account: {
          label: 'Conta'
        },
        accounts: {
          active: {
            label: 'Ativo'
          },
          inactive: {
            label: 'Inativo'
          },
          label: 'Contas'
        },
        actions: {
          status: {
            activate: {
              label: 'Ativar'
            },
            pause: {
              label: 'Pausar'
            }
          }
        },
        shippingFree: {
          label: 'Frete grátis'
        },
        shippingRules: {
          country: {
            label: 'Todo o país'
          },
          exclude_region: {
            label: 'Exceto algumas regiões'
          }
        },
        sizeGrids: {
          label: 'Guia de Medidas',
          waist: {
            label: 'Waisttt'
          }
        },
        migration: {
          done: {
            label: 'Migrado'
          },
          partial: {
            label: 'Parcialmente migrado'
          },
          pending: {
            label: 'Não migrado'
          },
          statusSynchronization: {
            synchronized: {
              label: 'Sincronizado'
            },
            waiting: {
              label: 'Processando'
            }
          }
        },
        officialStore: {
          label: 'Loja oficial'
        },
        types: {
          gold_pro: {
            label: 'Premium'
          },
          gold_special: {
            label: 'Clássico'
          },
          free: {
            label: 'Grátis'
          }
        },
        shippingOptions: {
          me1: {
            label: 'Mercado Envios 1'
          },
          me2: {
            label: 'Mercado Envios 2'
          },
          custom: {
            label: 'Personalizado'
          },
          not_specified: {
            label: 'Não especificado'
          },
          carrier: {
            label: 'Transportadora'
          }
        },
        synchronizeOrdersOptions: {
          'all': {
            label: 'Todos'
          },
          'none': {
            label: 'Nenhum'
          },
          'onlySynchronizedAnnouncement': {
            label: 'Somente de anúncios sincronizados'
          }
        },
        conditions: {
          new: {
            label: 'Novo'
          },
          used: {
            label: 'Usado'
          },
          not_specified: {
            label: 'Não especificado'
          }
        },
        label: 'Mercado Livre'
      },
      migrate: {
        label: 'Migrar'
      },
      migration: {
        label: 'Migração',
        done: {
          false: {
            label: 'Não migrado'
          },
          true: {
            label: 'Migrado'
          }
        },
        status: {
          done: {
            label: 'Migrado'
          },
          pending: {
            label: 'Não migrado'
          }
        },
        statusSynchronization: {
          synchronized: {
            label: 'Sincronizado'
          },
          waiting: {
            label: 'Processando'
          }
        },
        statusProductMarketplace: {
          true: {
            label: 'Ativo'
          },
          false: {
            label: 'Inativo'
          }
        }
      },
      module: {
        label: 'Módulo'
      },
      moovin: {
        label: 'Moovin'
      },
      name: {
        label: 'Nome'
      },
      ncm: {
        label: 'NCM'
      },
      netshoes: {
        gender: {
          female: {
            label: 'Mulher'
          },
          male: {
            label: 'Homem'
          },
          unisex: {
            label: 'Unissex'
          }
        },
        gridType: {
          size: {
            label: 'Tamanho'
          },
          flavor: {
            label: 'Sabor'
          },
          voltage: {
            label: 'Voltagem'
          }
        },
        label: 'Netshoes'
      },
      new: {
        label: 'Novo'
      },
      no: {
        label: 'Não',
        migration: {
          label: 'Não migrar'
        }
      },
      none: {
        label: 'Nenhum'
      },
      notContain: {
        label: 'Não contém'
      },
      not_synchronized: {
        label: 'Não sincronizado'
      },
      notSynchronized: {
        label: 'Não sincronizado'
      },
      notSynchronize: {
        label: 'Não sincronizar'
      },
      notSent: {
        label: 'Não enviado'
      },
      number: {
        label: 'Número'
      },
      oneeg: {
        label: '1EG'
      },
      ecomece: {
        label: 'Ecomece'
      },
      order: {
        item: {
          price: {
            label: 'Preço'
          }
        },
        label: 'Pedido'
      },
      operator: {
        label: 'Operador'
      },
      ordering: {
        label: 'Ordenação'
      },
      quantityItensPage: {
        label: 'Quantidade de itens por página'
      },
      orders: {
        label: 'Pedidos'
      },
      overdue: {
        label: 'Atrasado'
      },
      paused: {
        label: 'Pausado'
      },
      partially: {
        label: 'Parcialmente'
      },
      partially_synchronized: {
        label: 'Parcialmente sincronizado',
        message: {
          label: '| {quantity} variação com falha de sincronização | {quantity} variações com falha de sincronização'
        }
      },
      piece: {
        label: 'Parte'
      },
      partially_approved: {
        label: 'Parcialmente aprovado'
      },
      payment: {
        label: 'Pagamento'
      },
      pending: {
        label: 'Pendente'
      },
      percent: {
        label: 'Porcentagem sobre o preço de venda'
      },
      side: {
        label: 'Lado'
      },
      volume: {
        label: 'Volume'
      },
      phone: {
        label: 'Telefone'
      },
      phoneMobile: {
        label: 'Celular'
      },
      polishop: {
        label: 'Polishop'
      },
      sicoob: {
        label: 'Sicoob'
      },
      privalia: {
        label: 'Privalia'
      },
      decathlon: {
        label: 'Decathlon'
      },
      keepRunning: {
        label: 'KeepRunning'
      },
      ramarim: {
        label: 'Ramarim'
      },
      comfortflex: {
        label: 'Comfortflex'
      },
      sicredi: {
        label: 'Sicredi'
      },
      maisCorreios: {
        label: 'MaisCorreios'
      },
      presets: {
        label: 'Predefinições'
      },
      previous: {
        label: 'Anterior'
      },
      price: {
        current: {
          label: 'Preço atual'
        },
        auxiliary: {
          label: 'Porcentagem sobre o preço de venda'
        },
        custom: {
          fixed: {
            label: 'Fixo'
          },
          label: 'Preço customizado',
          method: {
            label: 'Método'
          },
          percent: {
            label: 'Percentual'
          },
          previousUpdate: {
            label: 'Atualizar preço antigo'
          }
        },
        fixedValue: {
          auxiliary: {
            label: 'Valor fixo'
          }
        },
        label: 'Preço',
        percent: {
          auxiliary: {
            label: 'Porcentagem'
          }
        },
        previous: {
          label: 'Preço antigo'
        },
        status: {
          label: 'Status'
        },
        type: {
          label: 'Tipo de preço'
        }
      },
      pricePaid: {
        label: 'Preço pago'
      },
      priceTypeModule: {
        label: 'Preço '
      },
      print: {
        label: 'Imprimir'
      },
      printShipmentLabelIntegracommerce: {
        label: 'Imprimir etiquetas de pedidos da Integracommerce'
      },
      printShipmentLabelMercadoLivre: {
        label: 'Imprimir etiquetas de pedidos do Mercado Livre'
      },
      product: {
        label: 'Produto',
        reduced: {
          label: 'Csv reduzido'
        }
      },
      productGroupedId: {
        label: 'Agrupador do produto'
      },
      productType: {
        label: 'Tipo de produto'
      },
      productTypes: {
        label: 'Tipos de produto'
      },
      sku: {
        label: 'SKUs'
      },
      skus: {
        label: 'SKUs'
      },
      products: {
        label: 'Produtos'
      },
      productIds: {
        label: 'Agrupadores'
      },
      productsSelected: {
        label: 'Nenhum produto selecionado | 1 produto selecionado | {count} produtos selecionados'
      },
      provide: {
        label: 'Disponibilizar'
      },
      quantity: {
        label: 'Quantidade'
      },
      queue: {
        label: 'Fila'
      },
      quotation: {
        label: 'Cotação'
      },
      reducer: {
        label: 'Redutor'
      },
      refunded: {
        label: 'Devolvido'
      },
      remove: {
        label: 'Remover'
      },
      required: {
        label: 'Campo obrigatório.'
      },
      referenceAddress: {
        label: 'Referência'
      },
      referenceCode: {
        label: 'Código de referência'
      },
      renner: {
        label: 'Renner'
      },
      priceOnlyDiff: {
        label: 'Apenas com alteração de preço'
      },
      ricardoEletro: {
        feed: {
          create: {
            label: 'Criar'
          },
          created: {
            label: 'Data de criação'
          },
          label: 'Carga',
          list: {
            label: 'Cargas'
          },
          queued: {
            false: {
              label: 'Não'
            },
            true: {
              label: 'Sim'
            }
          },
          statuses: {
            available: {
              label: 'Disponível para consulta'
            },
            created: {
              label: 'Criado'
            },
            done: {
              label: 'Finalizado'
            },
            error: {
              label: 'Erro'
            },
            processing: {
              label: 'Processando'
            },
            submitted: {
              label: 'Enviado'
            }
          },
          type: {
            label: 'Tipo',
            stock: {
              label: 'Estoque'
            },
            sync: {
              label: 'Produto'
            },
            order: {
              label: 'Pedido'
            },
            price: {
              label: 'Preço'
            }
          }
        },
        feeds: {
          label: 'Cargas'
        },
        label: 'Ricardo Eletro',
        status: {
          pending: {
            label: 'Aguardando carga'
          }
        }
      },
      saleAvailability: {
        available: {
          label: 'Disponível'
        },
        label: 'Disponibilidade de venda',
        queue: {
          label: 'Em fila'
        },
        unavailable: {
          label: 'Indisponível'
        }
      },
      saleChannel: {
        label: 'Canal de venda'
      },
      saleFee: {
        label: 'Taxa de venda'
      },
      save: {
        label: 'Salvar',
        price: {
          label: 'Salvar somente preço'
        }
      },
      scope: {
        label: 'Escopo'
      },
      sector: {
        label: 'Setor'
      },
      security: {
        label: 'Segurança'
      },
      sellerType: {
        label: 'Tipo de vendedor'
      },
      sellerName: {
        label: 'Nome do vendedor'
      },
      sendAmazon: {
        label: 'Disponibilizar produtos na Amazon'
      },
      sendCarrefour: {
        label: 'Disponibilizar produtos no Carrefour'
      },
      sendCentauro: {
        label: 'Disponibilizar produtos na Centauro'
      },
      sendCnova: {
        label: 'Disponibilizar produtos na Cnova'
      },
      sendColombo: {
        label: 'Disponibilizar produtos na Colombo'
      },
      sendConectaLa: {
        label: 'Disponibilizar produtos na Conecta Lá'
      },
      sendGfg: {
        label: 'Disponibilizar produtos no GFG'
      },
      sendIntegracommerce: {
        label: 'Disponibilizar produtos na Integracommerce'
      },
      sendLeroy: {
        label: 'Disponibilizar produtos na Leroy Merlin'
      },
      sendMadeira: {
        label: 'Disponibilizar produtos no Madeira Madeira'
      },
      sendMagalu: {
        label: 'Disponibilizar produtos na Magalu'
      },
      sendMercadoLivre: {
        label: 'Anunciar produtos no Mercado Livre'
      },
      sendNetshoes: {
        label: 'Disponibilizar produtos na Netshoes'
      },
      sendPolishop: {
        label: 'Disponibilizar produtos na Polishop'
      },
      sendSicoob: {
        label: 'Disponibilizar produtos na Sicoob'
      },
      sendPrivalia: {
        label: 'Disponibilizar produtos na Privalia'
      },
      sendDecathlon: {
        label: 'Disponibilizar produtos na Decathlon'
      },
      sendKeepRunning: {
        label: 'Disponibilizar produtos na KeepRunning'
      },
      sendRamarim: {
        label: 'Disponibilizar produtos na Ramarim'
      },
      sendComfortflex: {
        label: 'Disponibilizar produtos na Comfortflex'
      },
      sendSicredi: {
        label: 'Disponibilizar produtos na Sicredi'
      },
      sendMaisCorreios: {
        label: 'Disponibilizar produtos na Mais Correios'
      },
      sendRicardoEletro: {
        label: 'Disponibilizar produtos no Ricardo Eletro'
      },
      sendRenner: {
        label: 'Disponibilizar produtos na Renner'
      },
      sendShopee: {
        label: 'Disponibilizar produtos no Shopee'
      },
      sendSkyhub: {
        label: 'Disponibilizar produtos na Skyhub'
      },
      sendWalmart: {
        label: 'Disponibilizar produtos no Walmart'
      },
      sendWebcontinental: {
        label: 'Disponibilizar produtos na WebContinental'
      },
      sendZoom: {
        label: 'Disponibilizar produtos no Zoom'
      },
      sendTikTokShop: {
        label: 'Disponibilizar produtos no TikTok Shop'
      },
      sendShein: {
        label: 'Disponibilizar produtos na Shein'
      },
      sent: {
        label: 'Enviado'
      },
      shippingFee: {
        label: 'Taxa de frete'
      },
      shipment: {
        label: 'Frete'
      },
      shipmentLabel: {
        label: 'Etiqueta de envio'
      },
      shipmentService: {
        name: {
          label: 'Serviço de entrega'
        },
        true: {
          label: 'Sim'
        },
        false: {
          label: 'Não'
        }
      },
      syncInstallments: {
        name: {
          label: 'Sincronizar parcelas'
        },
        true: {
          label: 'Sim'
        },
        false: {
          label: 'Não'
        }
      },
      shipped: {
        label: 'Enviado'
      },
      shipping: {
        label: 'Enviado'
      },
      shippingMethods: {
        label: 'Formas de envio'
      },
      shippingPrice: {
        label: 'Frete'
      },
      shippingTypes: {
        express: {
          label: 'Expressa'
        },
        standard: {
          label: 'Normal'
        },
        economic: {
          label: 'Econômica'
        }
      },
      shopee: {
        account: {
          label: 'Conta'
        },
        accounts: {
          active: {
            label: 'Ativo'
          },
          inactive: {
            label: 'Inativo'
          },
          label: 'Contas'
        },
        actions: {
          status: {
            activate: {
              label: 'Ativar'
            },
            pause: {
              label: 'Pausar'
            }
          }
        },
        shippingFree: {
          label: 'Frete grátis'
        },
        conditions: {
          new: {
            label: 'Novo'
          },
          used: {
            label: 'Usado'
          },
          not_specified: {
            label: 'Não especificado'
          }
        },
        label: 'Shopee',
        module: {
          config: {
            typeFileNFe: {
              '1': {
                label: 'PDF'
              },
              '2': {
                label: 'JPEG'
              },
              '3': {
                label: 'PNG'
              },
              '4': {
                label: 'XML (Padrão)'
              }
            }
          }
        }
      },
      shorterTime: {
        label: 'Menor tempo'
      },
      size: {
        label: 'Tamanho'
      },
      skyhub: {
        ageGroup: {
          adult: {
            label: 'Adulto'
          },
          both: {
            label: 'Ambos'
          },
          kids: {
            label: 'Crianças'
          }
        },
        gender: {
          female: {
            label: 'Feminino'
          },
          male: {
            label: 'Masculino'
          },
          unisex: {
            label: 'Unissex'
          }
        },
        label: 'Skyhub'
      },
      source: {
        label: 'Fonte'
      },
      state: {
        label: 'Estado'
      },
      status: {
        label: 'Status'
      },
      statusAnnouncement: {
        label: 'Status do anúncio'
      },
      stock: {
        label: 'Estoque',
        reducer: {
          label: 'Redutor'
        }
      },
      store: {
        label: 'Loja'
      },
      street: {
        label: 'Rua'
      },
      subtotal: {
        label: 'Subtotal'
      },
      subDepartment: {
        label: 'Subdepartamento'
      },
      success: {
        label: 'Sucesso'
      },
      sizeMap: {
        label: 'Tamanho Marketplace'
      },
      synchronized: {
        label: 'Sincronizado',
        message: {
          label: 'Todas variações sincronizadas'
        }
      },
      synchronize: {
        label: 'Sincronizar'
      },
      task: {
        create: {
          label: 'Criar'
        },
        label: 'Tarefa'
      },
      reprocess: {
        label: 'Reprocessar CSV'
      },
      tasks: {
        changeAnnouncementStatus: {
          label: 'Alteração de status de anúncio',
          options: {
            activate: {
              label: 'Ativar'
            },
            pause: {
              label: 'Pausar'
            }
          }
        },
        fileReprocessOrder: {
          label: 'Reprocessar Pedidos com CSV'
        },
        exportProductCsv: {
          label: 'Exportar produtos em CSV'
        },
        createProductFeed: {
          label: 'Carga de criação de produto'
        },
        productReprocess: {
          label: 'Reprocessar produtos'
        },
        feedUpdatePrice: {
          label: 'Alteração de preço com carga'
        },
        fileUpdatePrice: {
          label: 'Alteração de preço com arquivo'
        },
        fileUpdateExternalId: {
          label: 'Correção de ID externo com arquivo'
        },
        reportProductError: {
          label: 'Relatório de Produtos com erro de ID Externo'
        },
        feedUpdateReducer: {
          label: 'Alteração de redutor com carga'
        },
        label: 'Tarefas',
        migrationAnnouncement: {
          label: 'Migração de anúncio'
        },
        inactivateProduct: {
          label: 'Inativar Produto'
        },
        printShipmentLabelTask: {
          label: 'Imprimir etiquetas de pedidos'
        },
        removeProduct: {
          label: 'Remover Produto'
        },
        reprocessFeedPrice: {
          label: 'Reprocessar preço com carga'
        },
        reprocessFeedProduct: {
          label: 'Reprocessar envio com carga'
        },
        reprocessFeedStock: {
          label: 'Reprocessar stock com carga'
        },
        reprocessPrice: {
          label: 'Reprocessar preço'
        },
        reprocessProduct: {
          label: 'Reprocessar produto'
        },
        reprocessStock: {
          label: 'Reprocessar estoque'
        },
        updatePrice: {
          label: 'Alteração de preço'
        },
        updateReducer: {
          label: 'Alteração de redutor'
        },
        exportOrderCsv: {
          label: 'Exportar pedidos em CSV'
        },
        reportOrderStatus: {
          label: 'Relatório de status de pedidos em CSV'
        }
      },
      errorSizeGridRange: {
        label: 'Erro de tamanhos aceitos. Confira o mínimo e máximo aceitos'
      },
      tikTokShop: {
        account: {
          label: 'Conta'
        },
        shop: {
          label: 'Loja'
        },
        warehouse: {
          label: 'Centro de distribuição'
        },
        accounts: {
          active: {
            label: 'Ativo'
          },
          inactive: {
            label: 'Inativo'
          },
          label: 'Contas'
        },
        actions: {
          status: {
            activate: {
              label: 'Ativar'
            },
            pause: {
              label: 'Pausar'
            }
          }
        },
        label: 'TikTok Shop'
      },
      shein: {
        account: {
          label: 'Conta'
        },
        shop: {
          label: 'Loja'
        },
        warehouse: {
          label: 'Centro de distribuição'
        },
        accounts: {
          active: {
            label: 'Ativo'
          },
          inactive: {
            label: 'Inativo'
          },
          label: 'Contas'
        },
        actions: {
          status: {
            activate: {
              label: 'Ativar'
            },
            pause: {
              label: 'Pausar'
            }
          }
        },
        label: 'Shein'
      },
      tiny: {
        label: 'Tiny'
      },
      title: {
        label: 'Título'
      },
      to: {
        label: 'Destino'
      },
      'to-fix': {
        label: 'Ajustar'
      },
      tool: {
        label: 'Ferramenta'
      },
      total: {
        label: 'Total'
      },
      totalItems: {
        label: 'Total de itens'
      },
      totally: {
        label: 'Totalmente'
      },
      totalValue: {
        label: 'Valor total'
      },
      tokens: {
        label: 'Tokens'
      },
      token: {
        label: 'Token',
        status: {
          true: {
            label: 'Ativo'
          },
          false: {
            label: 'Inativo'
          }
        }
      },
      true: {
        label: 'Sim'
      },
      type: {
        label: 'Tipo'
      },
      typeCheckout: {
        label: 'Tipo checkout'
      },
      typeSelection: {
        label: 'Tipo de seleção',
        multipleSelect: {
          label: 'Seleção múltipla'
        },
        select: {
          label: 'Única seleção'
        },
        text: {
          label: 'Texto'
        }
      },
      typeVariation: {
        label: 'Tipo de variação'
      },
      user: {
        label: 'Usuário'
      },
      users: {
        label: 'Usuários'
      },
      user_action: {
        label: 'Ações de usuários'
      },
      undefined: {
        label: 'Desconhecido'
      },
      unitWeight: {
        label: 'Unidade de peso',
        kg: {
          label: 'Quilograma'
        },
        g: {
          label: 'Grama'
        }
      },
      validationError: {
        greaterThan: {
          label: 'Campo deve ser maior do que \'{msg}\''
        },
        lessThan: {
          label: 'Campo deve ser menor do que \'{msg}\''
        },
        maxLength: {
          label: '| Máximo {msg} caractere. | Máximo {msg} caracteres.'
        },
        minLength: {
          label: '| Mínimo {msg} caractere. | Mínimo {msg} caracteres.'
        },
        minimum: {
          label: 'Mínimo {msg}. | Mínimo {msg}. | Mínimo {msg}.'
        },
        type: {
          label: 'Tipo de dado inválido.'
        }
      },
      values: {
        label: 'Valores'
      },
      variations: {
        count: {
          label: '0 variações | 1 variação | {count} variações'
        },
        label: 'Variações'
      },
      height: {
        label: 'Altura - Revise Valor Mín/Máx'
      },
      width: {
        label: 'Largura - Revise Valor Mín/Máx'
      },
      length: {
        label: 'Comprimento - Revise Valor Mín/Máx'
      },
      variationsCombination: {
        false: {
          label: 'Não'
        },
        true: {
          label: 'Sim'
        }
      },
      voltage: {
        label: 'Voltagem'
      },
      waiting: {
        label: 'Ag. processamento'
      },
      sizeGrids: {
        waist: {
          label: 'Circunferência Cintura'
        },
        hip: {
          label: 'Circunferência Quadril'
        },
        foot: {
          label: 'Comprimento Pé'
        },
        ankle: {
          label: 'Cintura > Tornozelo'
        },
        inseam: {
          label: 'Costura Interna > Tornozelo'
        },
        thigh: {
          label: 'Circunferência Coxa'
        }
      },
      walmart: {
        label: 'Walmart'
      },
      warranty: {
        label: 'Garantia'
      },
      warrantyTime: {
        label: 'Tempo de garantia'
      },
      webcontinental: {
        label: 'WebContinental'
      },
      yes: {
        label: 'Sim'
      },
      zipCode: {
        label: 'CEP'
      },
      zoom: {
        label: 'Zoom'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/i18n.js